// type="date_select"(年・月・日のselect)用。
// Railsのdate_selectは3つのselectに分かれており、そのままではform-validator.jsの
// data-rules(presence/before等)を適用できないため、結合した値をバリデーション用のhiddenにセットする。
$(() => {
  if (!$('.js-date-select').length) {
    return
  }

  // hidden(バリデーション用)に反映する
  // form-validator.jsのbefore/afterと同じくローカル時刻で比較させるため、YYYY-MM-DDT00:00形式にする
  let copyValue = (wrapper) => {
    let year = wrapper.find('select[name$="(1i)]"]').val()
    let month = wrapper.find('select[name$="(2i)]"]').val()
    let day = wrapper.find('select[name$="(3i)]"]').val()
    let output = wrapper.find('.js-date-select_output')
    if (!year || !month || !day) {
      output.val('')
    } else {
      output.val(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T00:00`)
    }
    return output
  }

  $('.js-date-select').each((i, el) => {
    copyValue($(el))
  })

  $('.js-date-select').on('change', 'select', (e) => {
    copyValue($(e.target).closest('.js-date-select')).trigger('change')
  })
})
